type GetPrimaryColor = (props: { primaryColor?: string }) => string;
export const getPrimaryColor: GetPrimaryColor = (props) => {
  return props?.primaryColor || "#1babbc";
};

export const getPrimaryColorOpacity10: GetPrimaryColor = (props) => {
  const red = parseInt(getPrimaryColor(props).substring(1, 3), 16);
  const green = parseInt(getPrimaryColor(props).substring(3, 5), 16);
  const blue = parseInt(getPrimaryColor(props).substring(5, 7), 16);
  return `rgba(${red}, ${green}, ${blue}, 0.1)`;
};